import { Image } from '~/components/Image';

import type { Recommendation } from '~/interfaces/recommendation';

interface Props {
  boost?: boolean;
  recommendation: Recommendation;
  selected: boolean;
  onToggle: (id: string) => void;
}

export default function RecommendationItem({ boost = false, recommendation, selected, onToggle }: Props) {
  return (
    <li className="">
      <div className="space-y-4">
        <button
          type="button"
          className="relative flex rounded-lg border border-[#E5E7EB] bg-[#F9FAFB] p-4 cursor-pointer transition-all hover:bg-gray-50 hover:border-gray-300 w-full text-left"
          onClick={() => onToggle(recommendation.id)}
        >
          <div
            className={`absolute top-4 right-4 rounded-md px-2 py-1 font-medium border shadow-sm pointer-events-none ${
              selected
                ? 'bg-wt-primary text-wt-text-on-primary border-wt-primary'
                : 'bg-gray-100 text-gray-700 border-gray-300'
            }`}
          >
            {selected ? 'Selected' : 'Select'}
          </div>
          <div className="w-full pr-20">
            <div className="mb-4 flex-shrink-0">
              <div className="h-14 w-14 overflow-hidden rounded border border-gray-300 bg-white">
                <Image
                  maxWidth={128}
                  aspectRatio={'square'}
                  src={recommendation.publication.thumbnail_image_url}
                  alt={recommendation.publication.name}
                />
              </div>
            </div>
            <div className="w-full space-y-0.5">
              {boost && <p className="text-xs text-gray-700">Sponsored</p>}
              <div className="flex flex-col space-y-2">
                <div className="flex flex-col space-y-0">
                  <h4 className="text-lg font-medium text-gray-900">{recommendation.publication.name}</h4>
                  <p className="line-clamp-2 text-sm text-gray-700">{recommendation.publication.description}</p>
                </div>
                {recommendation.reason && (
                  <span className="text-xs italic text-gray-700">"{recommendation.reason}"</span>
                )}
              </div>
            </div>
          </div>
        </button>
      </div>
    </li>
  );
}
